export default [
  {
    path: '/customer_cost',
    name: 'cost',
    meta: {keepAlive: false, pathName: 'cost',},
    component: resolve => require(['../view/customerCost/index'], resolve),
    children:[
      {
        path:'/cusc',
        name:'cusc',
        meta: {keepAlive: false, pathName: 'cusc',},
        component: resolve => require(['../view/customerCost/cusc'], resolve),
      },
      {
        path:'/clicks',
        name:'clicks',
        meta: {keepAlive: false, pathName: 'clicks',},
        component: resolve => require(['../view/customerCost/clicks'], resolve),
      },
      {
        path:'/exposure',
        name:'exposure',
        meta: {keepAlive: false, pathName: 'exposure',},
        component: resolve => require(['../view/customerCost/exposure'], resolve),
      }
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/customerCost.js